import React from 'react';
import Button from '@mui/material/Button';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTutorialContext } from '../../contexts/TutorialContext';
import './TutorialButton.scss';

const TutorialButton = () => {
  const { startTutorial, isActive } = useTutorialContext();

  if (isActive) {
    return null; // Ne pas afficher le bouton si le tutoriel est actif
  }

  return (
    <Button
      onClick={startTutorial}
      startIcon={<HelpOutlineIcon />}
      variant="outlined"
      size="small"
      className="tutorial-start-button"
      title="Démarrer le tutoriel"
    >
      Revoir le tutoriel
    </Button>
  );
};

export default TutorialButton;